import { Form, Select, Spin, Icon } from "src/Library/AntdLibComponents";
import * as React from 'react';
import { isUndefined } from "util";
import { stops } from "src/Library/Helper";

const renderWeightOrVolumeUnit = (form, classes, key, arrayList, initialValue, disabled?) : React.ReactElement => {
  return (
    <Form.Item>
      {form.getFieldDecorator(key, {
        initialValue,
      })(
        <Select
          getPopupContainer={(trigger: any) => trigger.parentNode}
          className={classes.selectField}
          showSearch
          optionFilterProp="children"
          placeholder="Unit"
          disabled={disabled}
        >
          {arrayList?.map(item =>
            <Select.Option key={item}>{item}</Select.Option>
          )}
        </Select>
      )}
    </Form.Item>
  );
};

const getMandatoryFields = (props) => {
  const getFieldValue = (key, defaultVal) => (
    isUndefined(SICountryValidations?.[countryId]?.[shipmentData?.type]?.[key])) ? defaultVal
  : SICountryValidations[countryId][shipmentData?.type][key];
  const {
    SICountryValidations,
    countryId,
    shipmentData
  } = props;
  const isHsCodeMandatory = getFieldValue('hsCode', true);
  const isNCMCodeMandatory = getFieldValue('ncmCode', false);
  const isContainerTareWeightMandatory = getFieldValue('containerTareWeight', false);
  const isShipperTaxIdMandatory = getFieldValue('shipperTaxId', false);
  const isCarrierTaxIdMandatory = getFieldValue('carrierTaxId', false);
  const isFilingStatusMandatory = getFieldValue('filingStatus', false);
  const mandatoryPartyInvolvedFields = getFieldValue('partiesInvolved', {});
  const mandatoryCustomsComplianceFields = getFieldValue('customsCompliance', {});
  const mandatoryReferenceNumbers = getFieldValue('referenceNumbers', []);

  return {
    isHsCodeMandatory,
    isNCMCodeMandatory,
    isShipperTaxIdMandatory,
    isCarrierTaxIdMandatory,
    isContainerTareWeightMandatory,
    mandatoryPartyInvolvedFields,
    mandatoryCustomsComplianceFields,
    isFilingStatusMandatory,
    mandatoryReferenceNumbers,
  };
};

enum siInttraStatus {
  ACCEPTED = 'ACCEPTED',
  REQUESTED = 'REQUESTED',
  REJECTED = 'REJECTED',
}

enum RequestStatus {
	IN_DRAFT = 'IN_DRAFT',
	PENDING = 'PENDING',
	VERIFIED = 'VERIFIED',
	REJECTED = 'REJECTED',
	REQUESTED = 'REQUESTED',
}

const getContainerStatus = (status) => {
  switch (status) {
    case RequestStatus.REQUESTED:
    case RequestStatus.PENDING: return {
      backgroundColor: 'rgba(237,135,50,0.15)',
      border: '1px solid #ED8732',
      title: 'Pending',
    }
    case RequestStatus.VERIFIED: return {
      backgroundColor: 'rgba(90,218,19,0.15)',
      border: '1px solid #5ADA13',
      title: 'Accepted'
    }
    case RequestStatus.REJECTED: return {
      backgroundColor: 'rgba(245,34,45,0.15)',
      border: '1px solid #F5222D',
      title: 'Rejected'
    }
    default: return {};
  }
};

const getOdexStatusAndColor = (status) => {
  switch (status) {
    case RequestStatus.VERIFIED: return {
      color: '#5ADA13', label: 'Accepted'
    };
    case RequestStatus.REQUESTED: return {
      color: '#ED8732', label: 'Requested'
    };
    case RequestStatus.PENDING: return {
      color: '#ED8732', label: 'Pending'
    };
    case RequestStatus.REJECTED: return {
      color: '#F5222D', label: 'Rejected'
    };
    case RequestStatus.IN_DRAFT: return {
      color: '#999999', label: 'Draft'
    };
    default: return;
  }
}

const getContainerStatusWiseActions = (props) => {
  const {
    item,
    isContainerStatusRefreshing,
    refreshContainerStatus,
    classes,
    handleRetryError,
  } = props;
  switch (item?.status) {
    case RequestStatus.REQUESTED:
    case RequestStatus.PENDING: return (
      isContainerStatusRefreshing ? <Spin /> :
      <Icon
        type="reload"
        style={{ color: '#424242', fontSize: '20px' }}
        onClick={(e) => {
          stops(e);
          refreshContainerStatus(item?.containerNumber);
        }}
      />
    )
    case RequestStatus.REJECTED: return (
      <div className={classes.retryError}
        onClick={handleRetryError}
      >
        Submit A New Request
      </div>
    )
    default: return;
  }
}

const TabNames = {
  FIRST: "Stakeholder and Service Details",
  SECOND: "Container and Cargo",
  THIRD: "Additional Details",
};

const TabDescription = {
  FIRST: 'Enter the details of the Stakeholders and services',
  SECOND: 'Enter the Cargo details and dimensions',
  THIRD: 'Enter the Payment details & BL instructions',
};

enum CurrentPage {
  FIRST = 'FIRST',
  SECOND = 'SECOND',
  THIRD = 'THIRD',
};

export {
  renderWeightOrVolumeUnit,
  getMandatoryFields,
  siInttraStatus,
  RequestStatus,
  getOdexStatusAndColor,
  getContainerStatus,
  getContainerStatusWiseActions,
  TabDescription,
  TabNames,
  CurrentPage,
};